

import React, { createContext, useContext, Component } from "react";
import { GlobalContext } from "../utils/globalprovider.js"
import OneUpLoad from "./onupload.js";
import Button from "../components/bases/button/button";
import imgClose from "./assets/close.png"
import "./upload.css"

const MyComponentUpload = createContext();

class Upload extends Component {

  static contextType = GlobalContext; 

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false, // Indique si on est en train de drag
      offsetX: 0, // Décalage horizontal entre la souris et la div
      offsetY: 0, // Décalage vertical entre la souris et la div
      x: 100, // Position initiale horizontale
      y: 100, // Position initiale verticale
      visible: this.props.visible,
      uploads: [],


    };
    // Liaison des méthodes
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    this.onFinish = this.onFinish.bind(this);

    this.onQuit = this.onQuit.bind(this);
  }


  addUpload(projectId, formulaire, type = 0, callback = null )
  {
    // 0 = Video 1 = transcription
    

    var uploads = this.state.uploads;
    uploads.push(
      {projectId:projectId, formulaire: formulaire, visible:true, type:type, callback:callback}
    )
    this.setState({visible: true, uploads:uploads})

    
  }

  
  handleMouseDown(event) {
    // Enregistre l'état de dragging et l'offset
    this.setState({
      isDragging: true,
      offsetX: event.clientX - this.state.x,
      offsetY: event.clientY - this.state.y,
    });
  }

  handleMouseMove(event) {
    // Si on est en train de drag, mettre à jour la position
    if (this.state.isDragging) {

      var innerdiv = document.getElementById("uploadmanagerdiv");
      const rect = innerdiv.getBoundingClientRect();
      const maxx = window.innerWidth - rect.width- 60;
      const maxy = window.innerHeight - rect.height - 40;


      var x = event.clientX - this.state.offsetX;
      var y = event.clientY - this.state.offsetY;

      if ( x > maxx) x = maxx;
      if ( y > maxy) y = maxy;

      if ( x <20) x=20;
      if ( y < 2) y=2;

      
      this.setState({
        x: x,
        y: y,
      });


    }
  }

  handleMouseUp() {
    // Arrêter le dragging
    this.setState({ isDragging: false });
  }

  componentDidMount() {
    // Ajout des écouteurs globaux pour le déplacement et le relâchement
    window.addEventListener("mousemove", this.handleMouseMove);
    window.addEventListener("mouseup", this.handleMouseUp);
  }

  componentWillUnmount() {
    // Nettoyage des écouteurs pour éviter les fuites de mémoire
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("mouseup", this.handleMouseUp);
  }


  onQuit()
  {
      this.setState({visible: false})
      
  }

  
  onFinish(index)
  {
    
    var uploads = this.state.uploads;
    uploads[index].visible=false;


    var visible = this.state.visible;
    if (visible)
    {
      visible = false;
      for (var i=0; i<this.state.uploads.length; i++)
        if ( uploads[i].visible) visible=true;
    }

    this.setState({visible: visible, uploads:uploads})
  }

  render() {

    var display="flex";
    if (!this.state.visible) display="none";

    var allupload =[];
    for (var i=0; i<this.state.uploads.length; i++)
    {

      allupload.push (<OneUpLoad id={i} 
        key={"upload_" + i}
        type = {this.state.uploads[i].type} 
        visible = {this.state.uploads[i].visible} 
        onfinish={this.onFinish} 
        projectId={this.state.uploads[i].projectId} 
        formulaire={this.state.uploads[i].formulaire} 
        callback={this.state.uploads[i].callback}/>)
    }

    const { x, y } = this.state;
    
    return (
      <div className="uploadManagerDiv"
        id = "uploadmanagerdiv"
        onMouseDown={this.handleMouseDown}
        style={{top: y, left: x,display:display}}
      >

        <div className="uploadManagerTitle"
        onMouseDown={this.handleMouseDown}>
          <div className="uploadManagerTitleText">
          {this.context.language=="fr"?"Téléversements":"Uploads"}
          </div>


          <div className="uploadManagerCloseButton">
            <Button image={imgClose} width={16} height={16} onClick={this.onQuit}/>
          </div>

        </div>

        {allupload}
      </div>
    );
  }
}

export default Upload;
